import React from 'react';
import SortByDropdown from '../../components/SortByDropdown';
import PropTypes from 'prop-types';
import { translateResourceString } from '../../../util/translationUtility';

class PaginationContainer extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const {
            attributes,
            paginationViewModel,
            onCurrentSortByChange,
            onAttributeChange,
            sortOptions,
        } = this.props;

        const lastItemNumber = paginationViewModel.CurrentItemsOnPage;
        const paginationText = translateResourceString(`/SearchApp/Pagination/Article/ItemCountFormatted`, lastItemNumber, paginationViewModel.ResultsTotal);

        const selectedAttributesSize = 3;

        const selectedAttributes = [];
        attributes.filter(attribute => attribute.Values.filter(x => x.Checked).map(checkedValue => {
            if (selectedAttributes.length < selectedAttributesSize) {
                selectedAttributes.push(
                    {
                        name: attribute.Name,
                        displayName: attribute.DisplayName,
                        value: checkedValue.Name
                    })
            }
        }));

        const sortBy =
            <div className="form-inline pagination-dropdown-wrapper">
                <SortByDropdown
                    {...paginationViewModel}
                    onCurrentSortByChange={onCurrentSortByChange}
                    sortOptions={sortOptions}
                />
            </div>

        return (
            <div className="pagination-wrapper">
                {selectedAttributes.length > 0
                    ?
                    <React.Fragment>
                        <div className="row mb-2">
                            <div className="col-12">
                                <div className="d-flex justify-content-between align-items-center">
                                    <label className="total-results hidden-sm hidden-xs body-text text-md">
                                        {paginationText}
                                    </label>
                                    {sortBy}
                                </div>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-12 d-flex">
                            </div>
                        </div>
                    </React.Fragment>
                    :
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-between">
                            <label className="total-results hidden-sm hidden-xs body-text text-md">
                                {paginationText}
                            </label>
                            {sortBy}
                            </div>
                        </div>
                    </div>
                }

            </div>
        );
    }
};

PaginationContainer.propTypes = {
    paginationViewModel: PropTypes.shape({
        ResultsTotal: PropTypes.number,
        CurrentItemsPerPage: PropTypes.number,
        CurrentPageIndex: PropTypes.number,
        CurrentSortBy: PropTypes.string,
        CurrentItemsOnPage: PropTypes.number
    }),
    onCurrentItemsPerPageChange: PropTypes.func,
    onCurrentSortByChange: PropTypes.func,
    onCurrentPageIndexChange: PropTypes.func,
    selectedCategory: PropTypes.shape({
        DisplayName: PropTypes.string,
    }),
    onSelectCategory: PropTypes.func
};

export default PaginationContainer;
